var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCaretUp = function SvgCaretUp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91888 0.238867L0.242419 4.84681C-0.0808065 5.1653 -0.0808065 5.6803 0.242419 5.9954L1.01954 6.76113C1.34276 7.07962 1.86543 7.07962 2.18521 6.76113L5.5 3.49492L8.81479 6.76113C9.13801 7.07962 9.66068 7.07962 9.98046 6.76113L10.7576 5.9954C11.0808 5.67691 11.0808 5.16191 10.7576 4.84681L6.08112 0.238867C5.76477 -0.0796223 5.24211 -0.0796223 4.91888 0.238867Z",
    fill: "#C4C4C4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaretUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret-up.ed717615.svg";
export { ForwardRef as ReactComponent };